import defaultConfig from './config/clients/default/config.json';
import chottoConfig from './config/clients/chotto/config.json';
import chargespotConfig from './config/clients/chargespot/config.json';
import homebaseConfig from './config/clients/homebase/config.json';
import shibuyaup from './config/clients/shibuyaup/config.json';
import fgn from './config/clients/fukuoka-growth-next/config.json';
import tokyoSims from './config/clients/tokyosims/config.json';
import ramenTech from './config/clients/fukuoka-ramen-tech/config.json';
import techstarsTokyo from './config/clients/techstars-tokyo/config.json';
import plugAndPlay from './config/clients/plug-and-play/config.json';
import topai from './config/clients/topai/config.json';
import agora from './config/clients/agora/config.json';
import osakaCity from './config/clients/osaka-city/config.json';
import tokyoAI from './config/clients/tokyoai/config.json';
import tiktokGaming from './config/clients/tiktok-gaming/config.json';
import moradoVentures from './config/clients/morado-ventures/config.json';
import katayama from './config/clients/katayama/config.json';
import shibuyaCity from './config/clients/shibuya-city/config.json';
import nec from './config/clients/nec/config.json';
import luma from './config/clients/luma/config.json';

import { ClientConfig } from './types';

const configs: ClientConfig[] = [
  // Add more clients here
  luma as ClientConfig,
  nec as ClientConfig,
  shibuyaCity as ClientConfig,
  katayama as ClientConfig,
  moradoVentures as ClientConfig,
  tiktokGaming as ClientConfig,
  tokyoAI as ClientConfig,
  osakaCity as ClientConfig,
  agora as ClientConfig,
  topai as ClientConfig,
  plugAndPlay as ClientConfig,
  techstarsTokyo as ClientConfig,
  ramenTech as ClientConfig,
  fgn as ClientConfig,
  homebaseConfig as ClientConfig,
  tokyoSims as ClientConfig,
  shibuyaup as ClientConfig,
  chargespotConfig as ClientConfig,
  chottoConfig as ClientConfig //default
];

/**
 * Load the corresponding client config if found matching the given subdomain,
 * roomId, or CNAME.
 */
export function loadMatchingClientConfig(props: {
  subDomain?: string,
  roomId?: string,
  cname?: string
}): ClientConfig | null {
  const { subDomain, roomId, cname } = props;

  for (const config of configs) {
    const { matcher } = config;

    const matchesSubdomain =
      subDomain && matcher.subDomains ? matcher.subDomains.indexOf(subDomain) > -1 : false;

    if (matchesSubdomain) {
      return config;
    }

    const matchesCname = matcher.cname ? matcher.cname === cname : false;

    if (matchesCname) {
      return config;
    }

    const matchesRoomId = roomId && matcher.roomId ?
      new RegExp(matcher.roomId).test(roomId) : false;

    if (matchesRoomId) {
      return config;
    }
  }

  return roomId ? chottoConfig : defaultConfig;
}

export function loadDefaultConfig() {
  return defaultConfig;
}
